import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Spinner = props => {
  var _props$color;
  return /*#__PURE__*/_jsxs("svg", {
    className: `animate-spin text-red ${props.className}`,
    "data-testid": "spinner-logo",
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "18",
      cy: "18",
      r: "16",
      stroke: "#E2E0E7",
      strokeWidth: "3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 18C34 26.8366 26.8366 34 18 34",
      stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : "#6F3FF5",
      strokeWidth: "3"
    })]
  });
};